import { useState } from "react";
import useApi from "./useApi";
import { API_ROUTES } from "lib/constants/api-constants";

interface ClinicUsersState {
  users: ClinicUser[];
  loading: boolean;
  error: string | null;
  getUsers: (
    role: ClinicUserRoles,
    onSuccess?: (users: ClinicUser[]) => void
  ) => void;

  addUser: (
    user: CreateUserRequest,
    onSuccess?: (users: ClinicUser) => void
  ) => void;
  updateUser: (
    user: CreateUserRequest,
    onSuccess?: (users: ClinicUser) => void
  ) => void;
}

const useClinicUsers = (): ClinicUsersState => {
  const [error, setError] = useState<string | null>();
  const [users, setUsers] = useState<ClinicUser[]>([]);
  const {
    getData: getClinicUsersRequest,
    loading: getClinicUsersRequestLoading,
  } = useApi<ClinicUser[]>();

  const {
    postData: addClinicUsersRequest,
    loading: addClinicUsersRequestLoading,
  } = useApi<ClinicUser>();

  const {
    putData: updateClinicUsersRequest,
    loading: updateClinicUsersRequestLoading,
  } = useApi<ClinicUser>();

  const getUsers = async (
    role: ClinicUserRoles,
    onSuccess?: (users: ClinicUser[]) => void
  ) => {
    setError(null);
    await getClinicUsersRequest(
      `${API_ROUTES.CLINIC_USER.getUserByRole}/${role}`,
      (value) => {
        setUsers(value);
        onSuccess?.(value);
      },
      setError
    );
  };

  const addUser = async (
    user: CreateUserRequest,
    onSuccess?: (users: ClinicUser) => void
  ) => {
    setError(null);
    await addClinicUsersRequest(
      API_ROUTES.CLINIC_USER.addUser,
      user,
      onSuccess,
      setError
    );
  };

  const updateUser = async (
    user: CreateUserRequest,
    onSuccess?: (users: ClinicUser) => void
  ) => {
    setError(null);
    await updateClinicUsersRequest(
      `${API_ROUTES.CLINIC_USER.updateUser}/${user.id}`,
      user,
      onSuccess,
      setError
    );
  };

  return {
    users,
    loading:
      getClinicUsersRequestLoading ||
      addClinicUsersRequestLoading ||
      updateClinicUsersRequestLoading,
    error,
    getUsers,
    addUser,
    updateUser,
  };
};

export default useClinicUsers;
